import React, {Component, useEffect, useState} from 'react';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {compose} from 'redux';
import * as fonts from '../../../../util/fonts';
import './styles.scss';
import AppWrapper from '../../../../components/app-wrapper';
import {strings} from '../../../../util/strings';
import {addToGlobalStyles, addToWizard} from '../../../../store/actions';
import ModalTemplate from '../../../../components/modal/ModalTemplate';
import {Column, Row} from '../../../../components/layout';
import AppButton from '../../../../components/app-button';
import App from '../../../../App';
import colors from '../../../../util/colors';
import AppParagraph from '../../../../components/app-paragraph';
import {labelsParagraphs} from '../../../../util/utility';

interface MyProfilePopupProps {
  user?: any;
  addToGlobalStyles?(value: any): void;
  selectedBu?: any;
  labels: typeof strings.pt.register;
  show: boolean;
  buStyles?: any;
  setShowModal(value: any): void;
  addToWizard?(value: any): void;
}

function MyProfilePopup({labels, show, setShowModal}: MyProfilePopupProps) {
  labelsParagraphs(labels);

  return (
    <div className="myProfilePopup-modal-content p-0">
      <ModalTemplate
        className="myProfilePopup-modal"
        show={show}
        onHide={() => setShowModal(false)}
        cross={true}
        hideFooter={true}>
        <Column className="myProfilePopup-column">
          <Row className="myProfilePopup-title-row">
            <p
              style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
              className="p-myProfilePopup">
              {labels?.register_myProfile_title}
            </p>
          </Row>
          <Row className="myProfilePopup-paragraph">
            <Column>
              <Row className="myProfile-text-row">
                <AppParagraph
                  className="paragraph-text"
                  label={labels?.register_myProfile_text}
                />
              </Row>
              <Row>
                <Link
                  className="myProfilePopup-anchor"
                  to={labels?.register_myProfile_link}>
                  {labels?.register_myProfile_link}
                </Link>
              </Row>
            </Column>
          </Row>
          <Row className="myProfilePopup-button">
            <AppButton onClick={() => setShowModal(false)} variant="secondary">
              {labels?.register_myProfile_consent}
            </AppButton>
          </Row>
        </Column>
      </ModalTemplate>
    </div>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  stringsDefault,
  wizard,
  globalStyles,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: stringsDefault.value.pt.register,
  wizard: wizard.value,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MyProfilePopup)
);
